(function(app, ng) {

    app.component("upcomingEvents",
        {
            templateUrl: "/App/Client/Components/upcomingevents-template.html",
            controller: upcomingEventsController,
            require: {
                clientSidebar: "^clientSidebar"
            }
        });

    upcomingEventsController.$inject = ["_", "$q", "$rootScope", "modalService", "scheduledTaskApi", "appointmentApi", "moment"];
    function upcomingEventsController(_, $q, $rootScope, modalService, scheduledTaskApi, appointmentApi, moment) {
        var $ctrl = this;
        window.upcoming = this;

        ng.extend($ctrl,
            {
                ui: {},
                modalService: modalService,
                tasks: [],
                appointments: []
            });

        this.$onInit = function () {
            $ctrl.client = this.clientSidebar.parent.client;
            $ctrl.currentUser = this.clientSidebar.parent.currentUser;
            var promises = [];

            promises.push(getClientIncompleteTasks($ctrl.client.Id).then(function (tasks) {
                tasks.forEach(task => {
                    const dueDate = moment(task.DueDate).format();
                    const allDay = moment(task.DueDate).hour(0).minute(0).second(0).format();

                    task.isAllDay = dueDate === allDay ? true : false;

                    const today = new Date();
                    today.setHours(0, 0, 0);

                    if (task.DueDate < today)
                        task.isOverdue = true;

                    else task.isOverdue = false;

                    $ctrl.tasks.push(task);
                });
            }));

            promises.push(getPersonAppointments($ctrl.client.Id).then(function (appointments) {
                $ctrl.appointments = appointments
                    .filter(appointment => !appointment.IsCompleted && moment(appointment.EndDate).isAfter(moment().startOf('day')))
                    .map(appoinment => {
                        const apptCopy = appoinment;
                        apptCopy.multiDay = !moment(appoinment.StartDate).isSame(appoinment.EndDate, 'date');  // See if event spans multiple days
                        return apptCopy;
                    });
            }));

            $ctrl.ui.loading = true;
            $q.all(promises).then(function () {
                $ctrl.ui.loading = false;
            });
        };

        function getClientIncompleteTasks(clientId) {

            return scheduledTaskApi.getClientIncompleteTasks(clientId).then(function(tasks) {
                return tasks;
            });
        }

        function getPersonAppointments(clientId, nextPageToken) {
            return appointmentApi.getClientAppointments(clientId, nextPageToken).then(function (appointments) {
                if (!appointments.NextPage) return appointments;
                return getPersonAppointments(clientId, appointments.NextPage).then(function (recursiveAppointments) {
                    return appointments = _.concat(appointments, recursiveAppointments);
                });
            });
        }

        $rootScope.$on("appointmentCreated",
            function (event, appointment) {
                if (!appointment.IsCompleted && appointment.StartDate >= (new Date()).setHours(0, 0, 0, 0));
                $ctrl.appointments.push(appointment);
            });

        $rootScope.$on("appointmentUpdated",
            function (event, appointment) {
                if (appointment.IsCompleted || appointment.StartDate < (new Date()).setHours(0, 0, 0, 0)) {
                    _.remove($ctrl.appointments,
                        function (appt) {
                            return appt.Id === appointment.Id;
                        });
                } else {
                    var index = _.findIndex($ctrl.appointments,
                        function (appt) {
                            return appt.Id === appointment.Id;
                        });

                    $ctrl.appointments.splice(index, 1, appointment);
                }
            });

        $rootScope.$on("appointmentDeleted",
            function (event, appointment) {
                _.remove($ctrl.appointments,
                    function (appt) {
                        return appt.Id === appointment.Id;
                    });
            });

        $rootScope.$on("scheduledTaskCreated",
            function (event, task) {
                $ctrl.tasks.push(task);
            });

        $rootScope.$on("scheduledTaskUpdated",
            function (event, task) {
                if (task.CompletedDate) {
                    _.remove($ctrl.tasks,
                        function (tsk) {
                            return tsk.Id === task.Id;
                        });
                } else {
                    var index = _.findIndex($ctrl.tasks,
                        function (tsk) {
                            return tsk.Id === task.Id;
                        });

                    $ctrl.tasks.splice(index, 1, task);
                }
            });

        $rootScope.$on("scheduledTaskDeleted",
            function (event, task) {
                _.remove($ctrl.tasks,
                    function (tsk) {
                        return tsk.Id === task.Id;
                    });
            });
    }

})(window.app, window.angular); //jshint ignore:line